import { FC, ReactNode, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import useScreenSize from "../../../custom-hooks/useScreenSize";
import SliderArrowRightSVG from "../svg/SliderArrowRightSVG";
import SliderArrowLeft from "../svg/SliderArrowLeftSVG";

interface MarketsSliderProps {
    children: ReactNode[];
}

const settings = {
    className: "slider variable-width",
    dots: false,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 2.1,
    responsive: [
        {
            breakpoint: 1199,
            settings: {
                slidesToShow: 2,
            },
        },
        {
            breakpoint: 649,
            settings: {
                slidesToShow: 1,
            },
        },
    ],
};

const MarketsSlider: FC<MarketsSliderProps> = (props) => {
    const [currentSlide, setCurrentSlide] = useState(1);
    const { upTo650 } = useScreenSize();
    const afterChange = (current: number) => {
        setCurrentSlide(Math.ceil(current + 1));
    };

    return (
        <div className="relative">
            <div className="absolute dmin2:top-[-80px] td4:top-[-65px] ti8:bottom-[-60px] mi2:bottom-[-60px] mi1:bottom-[-54px] mi5:bottom-[-54px] tmin4:right-[165px] ti8:right-[47.5%] mi2:right-[47%] mi1:right-[46.5%] mi5:right-[46%] flex items-center H16 text-[#848484]">
                <span>{currentSlide}</span>/<span>{upTo650 ? props.children.length : props.children.length - 1}</span>
            </div>
            <Slider
                {...settings}
                nextArrow={<SliderArrowRightSVG />}
                prevArrow={<SliderArrowLeft />}
                afterChange={afterChange}
            >
                {props.children.map((item, index) => (
                    <div key={`slider-image-${index}`}>{item}</div>
                ))}
            </Slider>
        </div>
    );
};

export default MarketsSlider;
